export default __webpack_public_path__ + "static/media/petshop.0b59a906.jpg";